import { PASSAGE_ID_SEPARATOR_MESSAGE, passageIdHasForbiddenSeparator } from '@/utils/passageValidation';

/**
 * The message to show instead of sending a generation request, or null.
 *
 * The passage library holds plain numbers, so the server refuses any "//" in
 * a selected passage's number (a composite included) on the normal path
 * (api/generation_jobs.py) as on the mock-test path (api/mocktest.py) -- and
 * names no passage in its answer. Legacy library passages may still carry
 * one; the user is told which numbers to fix, once each, in selection order.
 */
export function passageIdSeparatorError(
  passages: Array<{ passage_id?: string | null }>,
): string | null {
  const offending = Array.from(new Set(
    passages
      .map((passage) => passage.passage_id)
      .filter((passageId): passageId is string => passageIdHasForbiddenSeparator(passageId, { allowComposite: false })),
  ));
  if (offending.length === 0) return null;
  return `${PASSAGE_ID_SEPARATOR_MESSAGE} 다음 지문의 번호를 고친 뒤 다시 시도해 주세요.\n${
    offending.map((passageId) => `• ${passageId}`).join('\n')
  }`;
}
